import React, { useState } from "react";
import { useSelector } from "react-redux";

export default function BhaktiVision() {
  const authState = useSelector((state) => state.authReducer);
  const { isLoggedIn, userName, userCode } = authState || {};
    return (
      <div className="p-4 mx-auto">
        <div className="flex flex-col md:flex-row items-center md:items-start bg-gray-900 p-6 rounded-lg mb-8 gap-6">
          <div className="flex-shrink-0">
            <img
               src="/assets/imgFounders2.webp"
              alt="Milind Pagdhare"
              className="w-28 h-28 rounded-full border-2 border-yellow-400"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <blockquote className="border-l-4 border-yellow-400 pl-6 italic text-sm lg:text-lg text-gray-200">
              "Bhakti is not just an app — it is a pathway to inner growth and a doorway to divine possibilities."
            </blockquote>

            <footer className="mt-4 text-center lg:text-right text-sm text-yellow-300">
              Milind Pagdhare, Co-founder, Think5Whys, Transformation-as-a-Platform
            </footer>
          </div>
        </div>

        <div className="space-y-6 text-gray-200 px-8">
          <section>
            <h2 className="text-xl font-bold text-white mb-4 text-center">Why Bhakti Matters Today</h2>
            <p className="text-sm leading-relaxed">
              In every home—village or city—devotion brings clarity, strength, and balance. But guidance, consistency, 
              and community are hard to find. Bhakti brings all three together with simple daily tools anyone can follow. 
              No ashram needed. No long travel. Just devotion that fits your day and lifts your life.
            </p>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Learn, Grow & Transform — At Your Pace</h3>
            <ul className="space-y-2 list-disc list-inside text-sm">

              <li>
                <strong>Bhakti Learnings & Books:</strong>  
                Daily wisdom, short notes, and guided lessons—easy to follow even for beginners.
                (Supports your <strong>Learnings</strong> stack 📚)
              </li>

              <li>
                <strong>Satsang & Pravachan:</strong>  
                Join spiritual sessions anytime, anywhere—feel like Guruji is with you.
                (Part of your <strong>Daily Bhakti Cycle</strong> 🪔)
              </li>

              <li>
                <strong>bhaktiTube:</strong>  
                A safe video space for mantras, teachings, and stories—no distractions.
                (Your spiritual <strong>content ecosystem</strong> ▶️)
              </li>

              <li>
                <strong>Ashram Twin & MetaVerse:</strong>  
                Immerse yourself in virtual sacred spaces designed for focus and calm.
                (Bringing ancient experiences to <strong>modern mediums</strong> 🪄)
              </li>
            </ul>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Daily Bhakti Cycle — Build Inner Discipline</h3>
            <ul className="space-y-2 text-sm">

              <li>
                <strong>Daily Chant:</strong>  
                Count your mantra repetitions with beads-like precision—anytime.
                (Supports <strong>habit building</strong> 📿)
              </li>

              <li>
                <strong>Guruji’s Tasks & Learnings:</strong>  
                Small daily actions that purify, discipline, and uplift.
                (This powers <strong>your daily spiritual micro-steps</strong> 📜)
              </li>

              <li>
                <strong>DeepThinking:</strong>  
                Reflect in silence using structured prompts.
                (Your <strong>inner clarity engine</strong> 🧘)
              </li>

              <li>
                <strong>Bhakti Diary & Goal Board:</strong>  
                Track your emotions, gratitude, wins, and progress visually.
                (Supports <strong>Self Reflection</strong> 🪞)
              </li>

            </ul>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Earn with Devotion — The Right Way</h3>
            <ul className="space-y-2 text-sm">

              <li>
                <strong>Digital Income:</strong>  
                Simple devotional tasks, referrals, and contributions that reward consistency.
                (Structured under <strong>Digital Income</strong> 💸)
              </li>

              <li>
                <strong>Rewarding Videos & Ads:</strong>  
                Watch meaningful content and earn—no scams, no confusion.
                (Making <strong>screen time valuable</strong> 🎥📢)
              </li>

              <li>
                <strong>Kharcho Jeeto & Contests:</strong>  
                Participate in positive, uplifting challenges to win rewards.
                (Part of <strong>Contest & Rewards</strong> 🏆)
              </li>

            </ul>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Trusted Bhakti Marketplace</h3>
            <ul className="space-y-2 text-sm">
              <li><strong>Pooja Items:</strong> Pure essentials for home rituals—curated with care. 🪔</li>
              <li><strong>Bhakti Souvenirs:</strong> Spiritual keepsakes, gifts, and symbols of devotion. 🎁</li>
              <li><strong>Books & Services:</strong> Wisdom and rituals brought to your doorstep. 📖</li>
            </ul>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Your AI Guide — Bhakti AI</h3>
            <p className="text-sm leading-relaxed">
              Ask questions. Seek clarity. Understand scriptures.  
              Bhakti AI simplifies ancient knowledge, without altering its purity.
              (This strengthens <strong>Kritrim Medha</strong> 🤖)
            </p>
          </section>
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">Let’s Walk This Path Together</h3>
            <p className="text-sm leading-relaxed">
              Whether you chant daily, learn occasionally, or seek deeper meaning—Bhakti adapts to you.  
              With millions embracing digital devotion, this is the moment to begin your transformation.
            </p>

            <div className="text-center mt-6">
              <button className="px-6 w-64 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
                Start Your Bhakti Journey
              </button>
            </div>
          </section>
        </div>
      </div>
    );
  };